import { Flex } from '@grupoboticario/flora-react';
import { RichText } from 'prismic-reactjs';

import { ResponsiveFloraTypography } from 'components';

import Styles from './Reward.styles';
import { useLoyaltyIncentiveCampaign } from '../../hooks';

export const Reward = () => {
  const { data: incentiveCampaign } = useLoyaltyIncentiveCampaign();

  return (
    <Flex direction='column' gap='$6'>
      <Flex direction='column' gap='$4'>
        <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold' as='h3'>
          Premiação TOP {incentiveCampaign?.limit} Revendedores por faixa
        </ResponsiveFloraTypography>

        <ResponsiveFloraTypography color='$nonInteractivePredominant'>
          Confira os prêmios que você pode ganhar ao estar no Ranking TOP {incentiveCampaign?.limit}
          !
        </ResponsiveFloraTypography>
      </Flex>

      <Styles.RewardWrapper>
        {incentiveCampaign?.reward?.map((reward) => (
          <Styles.RewardCard key={`${reward.title}-reward-incentive`}>
            <Flex gap='$4' align='self-start'>
              <Styles.Image src={reward.image?.url} alt='' />

              <Styles.RewardInfo>
                <ResponsiveFloraTypography
                  fontSize='bodyLargeShort'
                  fontWeight='bold'
                  color='$nonInteractiveEmphasis'
                >
                  {reward.title}
                </ResponsiveFloraTypography>

                <ResponsiveFloraTypography>
                  <RichText render={reward.description} />
                </ResponsiveFloraTypography>
              </Styles.RewardInfo>
            </Flex>
          </Styles.RewardCard>
        ))}
      </Styles.RewardWrapper>
    </Flex>
  );
};
